import * as _ from 'lodash';
import { useContext, useEffect, useMemo, type VoidFunctionComponent } from 'react';

import { RouterContext, useParams } from '../../../contexts/RouterContext';
import { releaseGroupReleaseRoute } from '../../helpers/routes';
import { useReleaseGroupReleases } from '../hooks';

import Header from './Header';
import Report from './Report';
import VersionList from './VersionList';
import type { ReleaseGroupParams } from './types';

import styles from './ReleaseGroup.module.less';

const ReleaseGroup: VoidFunctionComponent = () => {
  const { slug, releaseGroupId, releaseId } = useParams<ReleaseGroupParams>();
  const { replacePath } = useContext(RouterContext);
  const releases = useReleaseGroupReleases(Number(releaseGroupId));

  useEffect(() => {
    const latestRelease = _.head(releases.value?.releases);
    if (!releases.isLoading && latestRelease && releaseId === 'latest') {
      replacePath(releaseGroupReleaseRoute(slug, Number(releaseGroupId), latestRelease.id));
    }
  }, [releases, slug, releaseGroupId, releaseId, replacePath]);

  const selectedRelease = useMemo(() => {
    return releases.value?.releases.find((r) => r.id === Number(releaseId));
  }, [releases, releaseId]);

  return (
    <div className={styles.wrapper}>
      <Header releases={releases} />

      <div className={styles.main}>
        <VersionList releases={releases} />

        <Report isLoading={releases.isLoading} release={selectedRelease} />
      </div>
    </div>
  );
};

export default ReleaseGroup;
